class Swiper {
	constructor(options) {
		this._default = {
			container: '.v5-swiper-main',
			item: '.v5-swiper-item',
			direction: 'vertical',
			activeClass: 'v5-dot-active',
			threshold: 50, // 手势切换最小距离
			duration: 300, // 切换过渡时间
			auto: false, // 自动播放标志
			loop: false, // 循环标志
			interval: 3000, // 自动播放时间间隔
			height: 'auto',
			minMovingDistance: 0
		};
		this._options = Object.assign(this._default, options);
		this._options.height = this._options.height.replace('px', '');
		this._start = {}; // touchstart 坐标
		this._move = {}; // touchmove 坐标
		this._end = {}; // touchend 坐标
		this._eventHandlers = {};
		this._prev = this._current = this._goto = 0; // 上页、当前页、下页索引
		this._width = this._height = this._distance = 0; // 宽、高、每页距离
		this._offset = [];
		this.$box = this._options.container;
		this.$container = this._options.container.querySelector('.v5-swiper-main');
		this.$items = this.$container.querySelectorAll(this._options.item);
		this.count = this.$items.length;
		this.realCount = this.$items.length; // real items length
		this._position = []; // used by go event
		this._firstItemIndex = 0;
		if (!this.count) {
			return;
		}
		this._init();
		this._auto();
		this._bind();
		this._onResize();
		return this;
	}

	_init() {
		if (this._options.loop) {
			this._loopTwoItems();
		}
		this._height = this._options.height === 'auto'
			? 'auto'
			: +this._options.height;
		this._updateItemWidth();
		this._initPosition();
		this._activate(this._current);
		this._setOffset();
		this._setTransfrom();
		this._loopRender();
	}

	_auto() {
		this.stop();
		if (this._options.auto) {
			this.timer = setTimeout(() => {
				this.next();
			}, this._options.interval);
		}
	}

	_updateItemWidth() {
		this._width = this.$box.offsetWidth;
		this._distance = this._options.direction === 'horizontal'
			? this._width
			: this._height;
	}

	_loop() {
		return this._options.loop && this.realCount >= 3;
	}

	_onResize() {
		this.resizeHandler = () => {
			setTimeout(() => {
				this._updateItemWidth();
				this._setOffset();
				this._setTransfrom();
			}, 100);
		};
		window.addEventListener('orientationchange', this.resizeHandler, false);
	}

	_initPosition() {
		for (let i = 0; i < this.realCount; i++) {
			this._position.push(i);
		}
	}

	_movePosition(position) {
		if (position > 0) {
			let firstIndex = this._position.splice(0, 1);
			this._position.push(firstIndex[0]);
		} else if (position < 0) {
			let lastIndex = this._position.pop();
			this._position.unshift(lastIndex);
		}
	}

	_setOffset() {
		this._offset = [];
		const index = this._position.indexOf(this._current);
		Array.prototype.slice.call(this.$items).forEach(($item, key) => {
			this._offset.push((key - index) * this._distance);
		});
	}

	_setTransition(duration) {
		duration = duration || (this._options.duration || 'none');
		let transition = duration === 'none' ? 'none' : duration + 'ms';
		Array.prototype.slice.call(this.$items).forEach(function ($item, key) {
			$item.style.webkitTransition = transition;
			$item.style.transition = transition;
		});
	}

	_setTransfrom(offset = 0) {
		Array.prototype.slice.call(this.$items).forEach(($item, key) => {
			let distance = this._offset[key] + offset;
			let transform = `translate3d(${distance}px, 0, 0)`;
			if (this._options.direction === 'vertical') {
				transform = `translate3d(0, ${distance}px, 0)`;
			}
			$item.style.webkitTransform = transform;
			$item.style.transform = transform;
		});
	}

	_bind() {
		this.touchstartHandler = (e) => {
			this.stop();
			this._start.x = e.changedTouches[0].pageX;
			this._start.y = e.changedTouches[0].pageY;
			this._setTransition('none');
		};
		this.touchmoveHandler = (e) => {
			let distance = 0;
			let hasScroll = false;
			this._move.x = e.changedTouches[0].pageX;
			this._move.y = e.changedTouches[0].pageY;
			let distanceX = this._move.x - this._start.x;
			let distanceY = this._move.y - this._start.y;
			let scrollDirX = Math.abs(distanceX) > Math.abs(distanceY);
			let scrollDirY = Math.abs(distanceX) < Math.abs(distanceY);
			if (this._options.direction === 'horizontal' && scrollDirX) {
				distance = distanceX;
				hasScroll = true;
			}
			if (this._options.direction === 'vertical' && scrollDirY) {
				distance = distanceY;
				hasScroll = true;
			}
			if (((this._options.minMovingDistance && Math.abs(distance) >= this._options.minMovingDistance) || !this._options.minMovingDistance) && hasScroll) {
				this._setTransfrom(distance);
			}
			hasScroll && e.preventDefault();
		};

		this.touchendHandler = (e) => {
			this._end.x = e.changedTouches[0].pageX;
			this._end.y = e.changedTouches[0].pageY;

			let distance = this._end.y - this._start.y;
			if (this._options.direction === 'horizontal') {
				distance = this._end.x - this._start.x;
			}

			distance = this.getDistance(distance);
			if (distance !== 0 && this._options.minMovingDistance && Math.abs(distance) < this._options.minMovingDistance) {
				return;
			}
			if (distance > this._options.threshold) {
				this.move(-1);
			} else if (distance < -this._options.threshold) {
				this.move(1);
			} else {
				this.move(0);
			}

			this._loopRender();
		};

		this.transitionEndHandler = (e) => {
			this._activate(this._current);
			let cb = this._eventHandlers.swiped;
			cb && cb.apply(this, [this._prev % this.count, this._current % this.count]);
			this._auto();
			this._loopRender();
			e.preventDefault();
		};
		this.$container.addEventListener('touchstart', this.touchstartHandler, false);
		this.$container.addEventListener('touchmove', this.touchmoveHandler, false);
		this.$container.addEventListener('touchend', this.touchendHandler, false);
		this.$items[1] && this.$items[1].addEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
	}

	// support when onlt two
	_loopTwoItems() {
		if (this.count === 2) {
			let div = document.createElement('div');
			let $item;
			for (let i = this.$items.length - 1; i >= 0; i--) {
				div.innerHTML = this.$items[i].outerHTML;
				$item = div.querySelector(this._options.item);
				$item.classList.add(`${this._options.item.replace('.', '')}-clone`);
				this.$container.appendChild($item);
			}
			this.realCount = 4;
		}
	}

	_loopRender() {
		if (this._loop()) {
			// delete cloneNode
			if (this._offset[this._offset.length - 1] === 0) {
				this.$container.appendChild(this.$items[0]);
				this._loopEvent(1);
			} else if (this._offset[0] === 0) {
				this.$container.insertBefore(this.$items[this.$items.length - 1], this.$container.firstChild);
				this._loopEvent(-1);
			}
		}
	}

	_loopEvent(num) {
		this._itemDestoy();
		this.$items = this.$container.querySelectorAll(this._options.item);
		this.$items[1] && this.$items[1].addEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
		this._movePosition(num);
		this._setOffset();
		this._setTransfrom();
	}

	getDistance(distance) {
		if (this._loop()) {
			return distance;
		} else {
			if (distance > 0 && this._current === 0) {
				return 0;
			} else if (distance < 0 && this._current === this.realCount - 1) {
				return 0;
			} else {
				return distance;
			}
		}
	}

	_moveIndex(num) {
		if (num !== 0) {
			this._prev = this._current;
			this._current += this.realCount;
			this._current += num;
			this._current %= this.realCount;
		}
	}

	_activate(index) {
		let clazz = this._options.activeClass;
		Array.prototype.forEach.call(this.$items, ($item, key) => {
			$item.classList.remove(clazz);
			if (index === Number($item.dataset.index)) {
				$item.classList.add(clazz);
			}
		});
	}

	_itemDestoy() {
		this.$items.length && Array.prototype.slice.call(this.$items).forEach(item => {
			item.removeEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
		});
	}

	stop() {
		this.timer && clearTimeout(this.timer);
	}

	next() {
		this.move(1);
		return this;
	}

	move(num) {
		this.go(this._current + num);
		return this;
	}

	go(index) {
		this.stop();

		index = index || 0;
		index += this.realCount;
		index = index % this.realCount;
		index = this._position.indexOf(index) - this._position.indexOf(this._current);

		this._moveIndex(index);
		this._setOffset();
		this._setTransition();
		this._setTransfrom();
		this._auto();
		return this;
	}

	on(event, callback) {
		if (this._eventHandlers[event]) {
			console.error(`[swiper] event ${event} is already register`);
		}
		if (typeof callback !== 'function') {
			console.error('[swiper] parameter callback must be a function');
		}
		this._eventHandlers[event] = callback;
		return this;
	}

	destroy() {
		this.stop();
		this._current = 0;
		this._setTransfrom(0);
		window.removeEventListener('orientationchange', this.resizeHandler, false);
		this.$container.removeEventListener('touchstart', this.touchstartHandler, false);
		this.$container.removeEventListener('touchmove', this.touchmoveHandler, false);
		this.$container.removeEventListener('touchend', this.touchendHandler, false);
		this._itemDestoy();
		// remove clone item (used by loop only 2)
		if (this._options.loop && this.count === 2) {
			let $item = this.$container.querySelector(`${this._options.item}-clone`);
			$item && this.$container.removeChild($item);
			$item = this.$container.querySelector(`${this._options.item}-clone`);
			$item && this.$container.removeChild($item);
		}
	}
}

export default Swiper;
